import { Component, OnInit, Output, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoansService, OperationsService, StorageService, DataService } from '../../_services/index';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';

declare var swal: any;

@Component({
  selector: 'app-creditcheck',
  templateUrl: './creditcheck.component.html',
  styleUrls: ['./creditcheck.component.css']
})
export class CreditcheckComponent implements OnInit {
  ready = false;
  loan: any;
  currentUser: any;
  subb: any;
  @Input('parentRouteId') parentRouteId: any;
  history: any;
  view = 'master';
  creditcheckrecord: any;
  @Input('where_') where_ = '1';
  where = 'loan';
  constructor(public dataService: DataService, public operationsService: OperationsService, public toastr: ToastrService, private location: Location,
    public router: Router, public route: ActivatedRoute, public loansService: LoansService, public storageService: StorageService) {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.dataService.reloadCreditCheck.subscribe(res => {
      this.getData();
    });
  }
  showSuccess(message) {
    this.toastr.success(message, 'Success!');
  }

  showError(message) {
    this.toastr.error(message, 'Error');
  }
  ngOnInit() {

    this.getData();

  }
  getData() {
    if (this.where_ == '1') {
      this.subb = this.route.parent.params.subscribe(params => {

        this.parentRouteId = +params["id"];
        this.operationsService.getLoanCreditCheck(this.currentUser.token, this.parentRouteId, this.where)
          .subscribe(result => {
            this.loan = result.loan;
            this.ready = true;
          });
      });
    } else {
      this.operationsService.getLoanCreditCheck(this.currentUser.token, this.parentRouteId, this.where)
        .subscribe(result => {
          this.loan = result.loan;
          this.ready = true;
        });
    }
  }
  refreshCreditCheck() {
    this.dataService.onOpenLoanChildModal.emit({ 'location': 'run_credit_check', loan: this.loan });
  }
  viewCreditCheckDetails(loan) {
    this.view = 'detail';
    this.creditcheckrecord = loan;
  }
  viewPDFCreditCheckDetails(loan) {
    this.view = 'pdfview';
    this.creditcheckrecord = loan;
  }
  showList() {
    this.view = 'master';
  }
  goBack() {
    this.location.back();
  }
}
